import { render, staticRenderFns } from "./ModelFunds.vue?vue&type=template&id=f170950a&scoped=true&"
import script from "./ModelFunds.vue?vue&type=script&lang=js&"
export * from "./ModelFunds.vue?vue&type=script&lang=js&"
import style0 from "./ModelFunds.vue?vue&type=style&index=0&id=f170950a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f170950a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VSkeletonLoader})
